// /frontend/src/components/layout/Footer.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaHouzz } from 'react-icons/fa';
import Logo from '../../assets/logo.png'; // Make sure path is correct

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white text-gray-800 pt-10 pb-6 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-start mb-8">
          {/* Logo and About Us */}
          <div className="mb-6 md:mb-0 md:w-1/3 pr-6">
            <img src={Logo} alt="Henderson Design Group" className="h-10 mb-3" />
            <div className="text-gray-600">
              <h3 className="font-bold mb-2">About Us</h3>
              <p className="text-sm mb-2">
                At Hale by Henderson, we believe that great design begins with a sense of place. We specialize in complete furniture packages — curated collections designed to transform an empty space into a home with ease and elegance.
              </p>
              <Link to="/our-story" className="text-teal-700 hover:text-teal-900 text-sm font-medium">
                Read more →
              </Link>
            </div>
          </div>
          
          {/* Shopping Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Shopping</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/browse" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Collection
                </Link>
              </li>
              <li>
                <Link to="/custom-design" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Design
                </Link>
              </li>
              <li>
                <Link to="/designer-packages" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Furniture Packages
                </Link>
              </li>
              <li>
                <Link to="/warranty" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Warranty
                </Link>
              </li>
              <li>
                <Link to="/returns" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Returns & Refunds
                </Link>
              </li>
              <li>
                <Link to="/shipping" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Shipping Info
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-teal-800 transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Information */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <div className="mb-4">
              <h4 className="font-medium">HAWAII</h4>
              <address className="text-gray-600 not-italic">
                4343 Royal Place<br />
                Honolulu, HI 96816<br />
                Telephone: <a href="tel:+18083158782" className="hover:text-teal-800 transition-colors">808.315.8782</a>
              </address>
            </div>
            
            <div>
              <h4 className="font-medium">EMAIL</h4>
              <a href="mailto:aloha@henderson.house" className="text-gray-600 hover:text-teal-800 transition-colors">
                aloha@henderson.house
              </a>
            </div>
            
            <div className="flex space-x-4 mt-6">
              <a href="https://web.facebook.com/HendersonDesignGroup/?_rdc=1&_rdr#" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-teal-800 transition-colors">
                <FaFacebook size={20} />
              </a>
              <a href="https://www.instagram.com/halebyhenderson/" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-teal-800 transition-colors">
                <FaInstagram size={20} />
              </a>
              <a href="https://www.houzz.com/professionals/interior-designers-and-decorators/henderson-design-group-pfvwus-pf~1543651721?" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-teal-800 transition-colors">
                <FaHouzz size={20} />
              </a>
            </div>
          </div>
        </div>
        
        {/* Copyright */}
        <div className="border-t border-gray-200 pt-6">
          <p className="text-gray-500 text-center">© {currentYear} Henderson Design Group. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;